import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, ValidatorFn, ValidationErrors, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, combineLatest, finalize, takeUntil } from 'rxjs';
import { ChangeRuleGetResponse, ChangeRulePostRequest } from 'src/app/models/interface/CAM/change-rules';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { PolicyManagementService } from 'src/app/services/dataLayer/CAM/policy-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { PolicyContentService } from '../../services/policy-content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { NgIf } from '@angular/common';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatCheckbox } from '@angular/material/checkbox';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-change-rule',
  templateUrl: './change-rule.component.html',
  styleUrls: ['./change-rule.component.scss'],
  imports: [ReactiveFormsModule, MatSlideToggle, NgIf, MatError, MatCheckbox, NgSelectComponent, AutoBlurSelectDirective, MatFormField, MatLabel, MatInput, MatButton, MatProgressSpinner]
})
export class ChangeRuleComponent implements OnInit, AfterViewInit {

  changeRuleForm!: FormGroup
  selectedIssueIds: any;

  reissueWindowDaysList: any[] = [];
  policyList: any;
  policyName: any;

  commonObj: any = {
    isSubmitting: false
  }

  userID: any;
  saveMode!: string;
  content: any;
  private readonly destroy$ = new Subject<void>();
  constructor(private readonly fb: FormBuilder, private readonly router: Router, private readonly _CryptoService: CryptoService, private _CompanyManagementService: CompanyManagementService,
    private readonly _ActivatedRoute: ActivatedRoute, private readonly _CamService: CamService, private readonly cryptoService: CryptoService, private readonly _ToastrApiService:
      ToastrApiService, public _CommonService: CommonService, private readonly policyService: PolicyManagementService, private readonly contentService: PolicyContentService, private readonly dictionaryContent: DisctionaryContent, private _PolicyManagement: PolicyManagementService) {
    this.changeRuleForm = this.fb.group(
      {
        isFlightchangeAllowed: [false],
        isRefundable: [false],
        isNonRefundable: [false],
        reissueWindowDays: [null,],
        reissueTicketLimit: [null,],
        maxADCAllowed: [null,],
        flag: 'SAVE'
      },
    );
  }

  ngOnInit() {
    this._CamService.policySaveMode$.pipe(takeUntil(this.destroy$)).subscribe(m => {
      this.saveMode = m;
    });

    combineLatest({ content: this.contentService.content$, dictionary: this.dictionaryContent.content$ }).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = { ...res.content, dictionary: res.dictionary };
    });
    this.reissueWindowDaysList = Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      name: `${i + 1} days`
    }));
    this.userID = this._CryptoService.decryptData(this._ActivatedRoute.snapshot.queryParams['enc'])?.policyID;
    this.getChangeRuleDetails();

    this.changeRuleForm.get('isFlightchangeAllowed')?.valueChanges
      .subscribe(value => {
        if (value) {
          this.changeRuleForm.patchValue({
            isRefundable: true
          }, { emitEvent: false });
        } else {
          this.changeRuleForm.patchValue({
            isRefundable: false,
          }, { emitEvent: false });
        }

      });

  }


  ngAfterViewInit() {
    this.policyService.policyListValue.subscribe((result: any) => {
      this.policyList = result
    })

    // this._PolicyManagementService.travelPolicyName.subscribe((result) => {
    //   this.policyName = result
    // })

    // this.policyName = this._CookiesService.getFromStorage()
    this._PolicyManagement.page_landing('Policy Management - Change rule', this.policyList.length, 'Policy Management Workflow')//GTM use
  }

  atLeastOneChangeRuleValidator(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {

      const reissueWindowDays = form.get('reissueWindowDays')?.value;
      const reissueTicketLimit = form.get('reissueTicketLimit')?.value;
      const maxADCAllowed = form.get('maxADCAllowed')?.value;

      if (!reissueWindowDays && !reissueTicketLimit && !maxADCAllowed) {
        return { atLeastOneRequired: true };
      }
      return null;
    };
  }

  savechangeRulesDetails(): void {
    if (this.changeRuleForm.hasError('atLeastOneRequired')) {
      this._ToastrApiService.show(
        'error',
        'Please select any change rules policy criteria'
      );
      return;
    }
    if (this.changeRuleForm.invalid || this.commonObj.isSubmitting) {
      this.changeRuleForm.markAllAsTouched();
      return;
    }

    const rawValue = this.changeRuleForm.value;

    const payload: ChangeRulePostRequest = {
      ...rawValue,
      reissueWindowDays: rawValue.reissueWindowDays || null,
      reissueTicketLimit: rawValue.reissueTicketLimit || null,
      maxADCAllowed: rawValue.maxADCAllowed || null
    };

    this.commonObj.isSubmitting = true;
    this._CamService.UpdatechangeRules(this.userID, payload).pipe(finalize(() => { this.commonObj.isSubmitting = false; })).subscribe({
      next: () => {
        let linkName = `Allow Flight Changes: ${rawValue?.isFlightchangeAllowed ? 'On' : ''} | Fare Type Permitted for Re-issue: ${rawValue?.isRefundable ? 'Refundable' : ''} | Reissue Window: ${rawValue?.reissueWindowDays} | Limit: ${rawValue?.reissueTicketLimit} | Maximum ADC Allowed: ${rawValue?.maxADCAllowed}`
        this.policyService.policy_rule_save(linkName);
        this.policyService.policy_rule_saveCont();
        this._PolicyManagement.save_success('Success', 'Save');
        this._ToastrApiService.show('success', 'Change rules saved successfully');
        // this.router.navigate(['/cam/policy-management/upgrade-policy'],
        //   { queryParams: { enc: this._CryptoService.encryptData({ policyID: this.userID }) } });

        this.router.navigate(["/cam/policy-management"]);

      },
      error: err => {
        console.error('Update failed', err);
        const message =
          err?.error?.message ||
          err?.message;
        this._PolicyManagement.view_error_message(message, err?.code);
      }
    });

  }


  getChangeRuleDetails(): void {
    this._CamService.GetChangePolicyRule(this.userID).subscribe({
      next: (res: { data: ChangeRuleGetResponse }) => {
        const result = res.data;
        this.changeRuleForm.patchValue({
          isFlightchangeAllowed: result.isFlightchangeAllowed,
          isRefundable: result.isRefundable,
          isNonRefundable: result.isNonRefundable,
          reissueWindowDays: result.reissueWindowsDays,
          reissueTicketLimit: result.reissueTicketLimit,
          maxADCAllowed: result.maxADCallowed
        });
      },
      error: (error) => {
        console.error('error', error);
        const message =
          error?.error?.message ||
          error?.message;
        this._PolicyManagement.view_error_message(message, error?.code);
      }
    });

  }


  navigateToList() {
    this.policyService.policy_change_click('Cancel'); // GTM use
    this._CamService.resetPolicyFormsMode();
    this.router.navigate(["cam", "policy-management"]);

  }

}
